import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { TimeInput24hsComponent } from './time-input-24hs.component';

@NgModule({
  imports: [CommonModule, ReactiveFormsModule, MatInputModule],
  declarations: [TimeInput24hsComponent],
  exports: [TimeInput24hsComponent],
})
export class TimeInput24hsModule {}
